export { CarComplectationInfo } from './CarComplectationInfo';
